const PATH = '/survey';
export const BACKOFF = [2, 1, 2, 1, 2, 1, 2, 3, 1];

let PATH_MORNING,
  PATH_MIDDAY,
  PATH_EVENING,
  PATH_SWEETS,
  PATH_BREAKFAST,
  PATH_SNACKS,
  PATH_GROCERY_HABITS;

let PATH_HELLO,
  PATH_DIETARY,
  PATH_RECIPES,
  PATH_PLAN,
  PATH_MEAT,
  PATH_SEAFOOD,
  PATH_PLANTS;
let paths;

PATH_HELLO = 0;
PATH_GROCERY_HABITS = 1;
PATH_DIETARY = 2;
PATH_MEAT = 3;
PATH_SEAFOOD = 4;
PATH_PLANTS = 5;
PATH_MORNING = 6;
PATH_MIDDAY = 7;
PATH_EVENING = 8;
PATH_SWEETS = 9;
PATH_BREAKFAST = 10;
PATH_SNACKS = 11;
PATH_RECIPES = 12;
PATH_PLAN = 13;

paths = {
  [PATH_HELLO]: `${PATH}/hello/`,
  [PATH_GROCERY_HABITS]: `${PATH}/grocery-shop/`,
  [PATH_DIETARY]: `${PATH}/dietary/`,
  [PATH_MEAT]: `${PATH}/meat/`,
  [PATH_SEAFOOD]: `${PATH}/seafood/`,
  [PATH_PLANTS]: `${PATH}/plants/`,
  [PATH_MORNING]: `${PATH}/morning/`,
  [PATH_MIDDAY]: `${PATH}/midday/`,
  [PATH_EVENING]: `${PATH}/evening/`,
  [PATH_SWEETS]: `${PATH}/sweets/`,
  [PATH_BREAKFAST]: `${PATH}/breakfast/`,
  [PATH_RECIPES]: `${PATH}/recipes/`,
  [PATH_SNACKS]: `${PATH}/snacks/`,
  [PATH_PLAN]: `${PATH}/plan/`,
};

export const PATHS = paths;

export const GOALS_SURVEY = {
  1: { value: 1, optionText: 'Eat more plants' },
  2: { value: 2, optionText: 'Improve health' },
  3: { value: 3, optionText: 'Lose weight' },
  4: { value: 4, optionText: 'Grocery shop less' },
  5: { value: 5, optionText: 'Save time' },
  // 6: { value: 6, optionText: "Try new food" }, replaced with goal 7
  7: { value: 7, optionText: 'Save money' },
};

export const DIETARY_PREFERENCES = {
  VEGAN: 'is_vegan',
  VEGETARIAN: 'is_vegetarian',
  GLUTEN_FREE: 'is_gluten_free',
  DAIRY_FREE: 'is_dairy_free',
  NUT_FREE: 'is_nut_free',
  SOY_FREE: 'is_soy_free',
  PESCATARIAN: 'is_pescatarian',
  EGG_FREE: 'is_egg_free',
  PEANUT_FREE: 'is_peanut_free',
  SHELLFISH_FREE: 'is_shellfish_free',
};

//occasions:
const GROCERY_ITEMS = 0;
const BREAKFAST = 1;
const LUNCHES = 2;
const DINNERS = 3;
const SNACKS = 4;
const SWEETS = 5;
const FRUITS = 6;
const KIDS = 8;

export const OCCASIONS = {
  [GROCERY_ITEMS]: 'Grocery Items',
  [BREAKFAST]: 'Breakfasts',
  [LUNCHES]: 'Lunches',
  [DINNERS]: 'Dinners',
  [SNACKS]: 'Snacks',
  [SWEETS]: 'Sweets',
  [FRUITS]: 'Fruits',
  [KIDS]: 'Kids',
};

export const OCCASIONS_CUSTOMIZE_FILTER = {
  [GROCERY_ITEMS]: 'Grocery Items',
  [BREAKFAST]: 'is_breakfast',
  [LUNCHES]: 'Lunches',
  [DINNERS]: 'Dinners',
  [SNACKS]: 'Snacks',
  [SWEETS]: 'Sweets',
  [FRUITS]: 'Fruits',
};

export const OCCASION_TO_EDIT_DELIVERY_HACK = {
  4: 'is_snacks=1',
  5: 'is_sweets=1',
  6: 'is_produce=1',
  [KIDS]: 'is_kids=1',
};

export const NONMEAL_OCCASIONS = [
  BREAKFAST,
  FRUITS,
  SNACKS,
  SWEETS,
  KIDS,
  GROCERY_ITEMS,
]; // OCCASIONS[1], OCCASIONS[4], OCCASIONS[5], OCCASIONS[6]

export const OCCASIONS_SORT_ORDER = [
  BREAKFAST,
  FRUITS,
  LUNCHES,
  DINNERS,
  SNACKS,
  SWEETS,
  KIDS,
  GROCERY_ITEMS,
];

export const DIETARY_TAG_MAP = {
  Vegan: 'is_vegan',
  Vegetarian: 'is_vegetarian',
  'Gluten-Free': 'is_gluten_free',
  'Nut-Free': 'is_nut_free',
  'Soy-Free': 'is_soy_free',
};

export const orderId = window.orderId || -1;
export const customerName = window.customerName || '';

//Tags

// Tags preferences states:
export const TAG_NO_THANKS = -1;

// PROTEIN TAGS
const BEEF_TAG = 1;
const POULTRY_TAG = 2;
const PORK_TAG = 3;
const FRESH_FISH_TAG = 4;
const SHELLFISH_TAG = 5;
const SMOKED_FISH_TAG = 6;
const TOFU_TEMPEH_TAG = 7;
const BEANS_LENTIS_TAG = 9;
const PLANT_BASED_MEAT_ALTERNATIVE_TAG = 10;
const LAMB_TAG = 16;

// New Meat
const BISON_TAG = 794;
const STEAK_TAG = 795;
const GROUND_BEEF_TAG = 802;
const TURKEY_TAG = 803;
const CHICKEN_TAG = 804;

// New Seafood
const TUNA_TAG = 796;
const TROUT_TAG = 797;
const WHITEFISH_TAG = 798;
const SALMON_TAG = 801;

// POLARIZING TAGS
const GLUTEN_FREE = 11;
const PLANT_BASED_CHEESE = 12;
const PLANT_BASED_EGG = 13;

export const MEAT_TAGS = [
  BEEF_TAG,
  POULTRY_TAG,
  PORK_TAG,
  LAMB_TAG,
  BISON_TAG,
  STEAK_TAG,
  GROUND_BEEF_TAG,
  TURKEY_TAG,
  CHICKEN_TAG,
];
export const SHELLFISH_TAGS = [SHELLFISH_TAG];
export const SOY_TAGS = [TOFU_TEMPEH_TAG];
export const SEAFOOD_TAGS = [
  SHELLFISH_TAG,
  FRESH_FISH_TAG,
  SMOKED_FISH_TAG,
  TUNA_TAG,
  TROUT_TAG,
  WHITEFISH_TAG,
  SALMON_TAG,
];
export const PLANTS_TAGS = [
  TOFU_TEMPEH_TAG,
  BEANS_LENTIS_TAG,
  PLANT_BASED_MEAT_ALTERNATIVE_TAG,
  PLANT_BASED_EGG,
  PLANT_BASED_CHEESE,
];
export const ACTIVE_PROTEIN_TAGS = {
  [BEEF_TAG]: true,
  [POULTRY_TAG]: true,
  [PORK_TAG]: true,
  [FRESH_FISH_TAG]: true,
  [SHELLFISH_TAG]: true,
  [SMOKED_FISH_TAG]: true,
  [TOFU_TEMPEH_TAG]: true,
  [BEANS_LENTIS_TAG]: true,
  [PLANT_BASED_MEAT_ALTERNATIVE_TAG]: true,
  [LAMB_TAG]: true,
};

export const POLARIZING_TAGS = [
  GLUTEN_FREE,
  PLANT_BASED_CHEESE,
  PLANT_BASED_EGG,
];

// ORDER GROUPING STATUS
export const INYOURFRIDGE = 1;
export const ONTHEWAY = 10;
export const INYOURFUTURE = 20;

// Spicy levels:
const SPICY_NONE = 0;
const SPICY_MILD = 1;
export const SPICY_MEDIUM = 2;
const SPICY_HOT = 3;
export const SPICY_LEVELS = [SPICY_NONE, SPICY_MILD, SPICY_MEDIUM, SPICY_HOT];

// Map tags ids to spicy Levels:
export const SPICY_TAGS_MAP = {
  19: SPICY_NONE,
  20: SPICY_MILD,
  21: SPICY_MEDIUM,
  22: SPICY_HOT,
};

export const SPICY_TAG_GROUP = 6;

// Tag Groups
export const BFAST_TAG_GROUP = 8;
export const SNACK_TAG_GROUP = 9;
export const POLARIZING_TAG_GROUP = 5;
export const MEAT_PROTEIN_TAG_GROUP = 1;
export const SEAFOOD_PROTEIN_TAG_GROUP = 2;
export const PLANT_PROTEIN_TAG_GROUP = 3;
